import { PassengersPageId } from '../../../../../app/pages/domain/constants/PageId';
import { useUrlForPageId } from '../../../../../app/pages/ui/utils/useUrlForPageId';
import { useNewBookingStore } from '../../../../domain/booking/stores/useNewBookingsStore';
import { useValidationResultMemo } from './useValidationResultMemo';

export function useHasBookingDate() {
	const { booking } = useNewBookingStore();
	const { entryDate, exitDate } = booking;

	return !!entryDate && !!exitDate;
}

export function useBookingDateValidation() {
	const isValid = useHasBookingDate();
	const redirectUrl = useUrlForPageId(PassengersPageId.Parking);

	return useValidationResultMemo({
		isValid,
		redirectUrl,
	});
}
